export default {"src":"/_next/static/media/chilepeppers.50a5a2e3.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};